import { CartItem } from './CartResult';
import { SkuList } from './SkuList';

export class PackageList {
    collection: SkuList[] = [];
    public item!: CartItem;

    public static fromItems(items: CartItem[]) {
        const list = new PackageList();
        const packages = {};

        items.forEach((item) => {
            if (
                item.model_id &&
                (item.model_type === 'Wooter\\WApparelPackage' || item.model_type === 'package') &&
                item.package_uuid
            ) {
                if (!packages[item.package_uuid]) {
                    packages[item.package_uuid] = new SkuList();
                }

                packages[item.package_uuid].add(item, false);
                packages[item.package_uuid].setItem(item);
            }
        });

        Object.entries(packages).forEach(([, items]) => {
            list.addCollection(items as any);
        });

        return list;
    }

    public addCollection(skuList: SkuList) {
        const item = skuList.collection[0];

        skuList.attachPackage(item.package);
        skuList.attachPrice(item.price);
        skuList.attachThumbnail(item.thumbnail);

        this.collection.push(skuList);

        return this;
    }

    public count() {
        return this.collection?.length || 0;
    }
}
